export const invalidVariableCharacterRegex = /[^\w-.]/g;